/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useCallback } from 'react';
import cls from 'classnames';
import { useRouter } from 'next/router';
import Cookies from 'js-cookie';
import Image from 'next/image';
import { OFFICIAL_WEBSITE_URL, CURRENT_LANGUAGE } from '../../utils/constants';
import styles from './style.module.scss';

interface NavProps {
  className?: string;
}

const Nav = ({ className }: NavProps) => {
  const router = useRouter();
  const { locale } = router;
  const [showLanguage, setShowLanguage] = useState(false);
  const handleLanguageClick = useCallback(() => {
    setShowLanguage(!showLanguage);
  }, [showLanguage]);

  const handleChangeLanguage = () => {
    const localeType = locale === 'zh' ? 'en' : 'zh';
    Cookies.set(CURRENT_LANGUAGE, localeType);
    const isProd = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';
    const basePath = isProd ? '/hm' : '';
    const enPath = locale === 'en' ? '' : '/en';
    const path = `${basePath}${enPath}${router.pathname}${window.location.search}`;
    router.push(path);
  };

  return (
    <div className={cls(className, styles.wrapper)}>
      <div className={styles.logoBox}>
        <a target="_blank" href={OFFICIAL_WEBSITE_URL} rel="noreferrer">
          <span className={styles.logoBoxImg}>
            <Image src="/images/logo.svg" alt="logo" width={101} height={34} layout="responsive" />
          </span>
        </a>
      </div>
      <div
        className={cls(styles.languageBox, {
          [styles.languageBoxActive]: showLanguage,
        })}
      >
        <div className={cls(styles.languageTextBox)} onClick={handleLanguageClick}>
          <span className={cls(styles.languageText)}>{locale === 'en' ? 'ENGLISH' : '中文'}</span>
        </div>
        <div className={cls(styles.languageSelectBox)}>
          <div className={cls(styles.languageSelectItem)}>
            <a
              className={cls(styles.languageItemText, {
                [styles.languageItemActive]: locale === 'zh',
              })}
              onClick={handleChangeLanguage}
            >
              中文
            </a>
          </div>
          <div className={cls(styles.languageSelectItem)}>
            <a
              className={cls(styles.languageItemText, {
                [styles.languageItemActive]: locale === 'en',
              })}
              onClick={handleChangeLanguage}
            >
              ENGLISH
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nav;
